/*
 * Copyright (c) 2019. Nedaware SL
 */

/**
 * Personalised encoder, based on the default encoder provided by
 * Angular, which performs the parameter conversion correctly
 * for our API (if not, dates failed when  sent)
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
import {HttpParameterCodec} from '@angular/common/http';

export class HttpUrlEncodingCodecCorrected implements HttpParameterCodec {
    encodeKey(k: string): string {
        return standardEncoding(k);
    }

    encodeValue(k: string): string {
        return standardEncoding(k);
    }

    decodeKey(k: string): string {
        return decodeURIComponent(k);
    }

    decodeValue(v: string) {
        return decodeURIComponent(v);
    }
}

function standardEncoding(v: string): string {
    return encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%3D/gi, '=')
        .replace(/%3F/gi, '?')
        .replace(/%2F/gi, '/');
}
